import { createSelector } from 'reselect';

const createRuntimeCapabilitySelector = ({ runtimeCapabilitiesSelector, capabilityKey }) => {
  return createSelector([runtimeCapabilitiesSelector], (capabilities) => {
    return capabilities?.[capabilityKey] === true;
  });
};

export default createRuntimeCapabilitySelector;
